export const MODULE_ALLOW_NESTED_ADVANCED_FILTER = [
  'productinformation',
  'onixpublicationfileinformation',
  'alcoholinformation',
  'allergeninformation',
  'animalfeeding',
  'apparelinformation',
  'audienceorplayerinformation',
  'audiovisualmediacontentinformation',
  'audiovisualmediaproductdescriptioninformation',
  'audiovisualmediaproductioninformation',
  'awardprize',
  'batteryinformation',
  'certificationinformation',
  'chemicalregulationinformation',
  'childnutritioninformation',
  'consumerinstructions',
  'controlledsubstance',
  'copyrightinformation',
  'dairyfishmeatpoultryitem',
  'dangeroussubstanceinformation',
  'deliverypurchasinginformation',
  'dietinformation',
  'durablegoodscharacteristics',
  'dutyfeetaxinformation',
  'electronicdevicecharacteristicsinformation',
  'farmingandprocessinginformation',
  'foodandbeverageingredient',
  'foodandbeveragepreparationserving',
  'foodandbeveragepropertiesinformation',
  'healthcareiteminformation',
  'healthrelatedinformation',
  'healthwellnesspackagingmarking',
  'lightingdevice',
  'marketinginformation',
  'medicaldevicetradeitem',
  'movierevenueinformation',
  'nonfoodingredient',
  'nongtinlogisticsunitinformation',
  'organismclassification',
  'packaginginformation',
  'packagingmarking',
  'packagingsustainability',
  'sustainability',
  'pharmaceuticaliteminformation',
  'physicalresourceusageinformation',
  'placeofitemactivity',
  'plumbinghvacpipeinformation',
  'productcharacteristics',
  'productformulationstatement',
  'promotionaliteminformation',
  'propellantinformation',
  'publicationtitlerating',
  'referencedfiledetailinformation',
  'regulatedtradeitem',
  'safetydatasheet',
  'salesinformation',
  'securitytaginformation',
  'softwaresystemrequirements',
  'textilematerial',
  'tradeitemdatacarrierandidentification',
  'tradeitemdescription',
  'tradeitemdisposalinformation',
  'tradeitemhandling',
  'tradeitemhumidityinformation',
  'tradeitemlicensing',
  'tradeitemlifespan',
  'tradeitemmeasurements',
  'tradeitemsize',
  'tradeitemtemperatureinformation',
  'transportationhazardousclassification',
  'variabletradeiteminformation',
  'videodisplaydeviceinformation',
  'warrantyinformation',
  'opticsdeviceinformation',
  'tradeitemhierarchy',
  'nutritionalinformation',
  'qaspecification',
  'supplementinformation',
  'druginformation',
];

export const MAXIMUM_QUERY_CONDITIONS = 50;
export const MAXIMUM_DATA_COLUMNS = 200;

export const DEFAULT_OPERATION = 'OR';

export const ADVANCED_FILTER_MODE = {
  NESTED_DATA: 'nested-data',
  FLAT_DATA: 'flat-data',
};

export const ADD_QUERY = {
  FILTER: 'FILTER',
  GROUP: 'GROUP',
};

export const UPDATE_COLUMNS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE',
  CLEAR: 'CLEAR',
  UP: 'UP',
  DOWN: 'DOWN',
};

export const FIELDS_CHANGED = [
  'fieldsChanged.fieldPath',
  'fieldsChanged.lastChanged',
];

export const APL_FIELDS = ['aplQuery.SearchSet'];

export const INITIAL_SEARCH_SET_CONDITION = {
  operation: 'OR',
  isNestedContainer: false,
  children: [
    {
      id: 'b31b9252-1d72-4c32-8667-5ac0e258b163',
      fieldName: 'aplQuery.SearchSet',
      operator: 'Equal',
      value: null,
      children: null,
    },
  ],
  strictMode: false,
  advancedFilterMode: 'flat-data',
  fieldName: null,
};
export const DELIVERY_METHOD = ['email', 'ftp'];
export const REPORT_EXPORT_TYPE_ADVANCED = ['XLS', 'XLSX', 'JSON', 'XML'];
export const REPORT_EXPORT_TYPE_FLAT = ['XLS', 'XLSX', 'CSV', 'JSON', 'XML'];

export const SEARCH_SET_APL_QUERY = {
  fieldName: 'aplQuery.SearchSet',
  aplQuerySearchSetEntity: 'aplQuery.searchSet_entity',
  aplQueryEntity: 'aplQuery_entity',
};

export const FIELDS_CHANGED_FIELD_PATH = 'fieldsChanged.fieldPath';

export const IS_PRODUCT_OVERLAY = 'isOverlayProduct';
export const INCLUDE_ALL_HIERARCHIES = 'includeAllHierarchies';
export const FLAT_DATA_MODULE = 'flatDataModule';
